/**
 * @generated SignedSource<<9e9ebc836071cf880529f16bc51c6929>>
 * @relayHash 02f09c77549cfaf3bb5ab375497855aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b0772f176e59fd48837be217e75a3ed8d5f7c6116af1154314d5f43b3e4fad53

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type LevelUpSettingsQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type LevelUpSettingsQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly created: AGG$DateTime | null | undefined;
    readonly projectStyle: JiraProjectStyle | null | undefined;
    readonly projectType: JiraProjectType | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AutomationsSection" | "ConfigurationSection">;
  };
};
export type LevelUpSettingsQuery = {
  response: LevelUpSettingsQuery$data;
  variables: LevelUpSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "created"
},
v3 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v4 = {
  "kind": "ScalarField",
  "name": "projectStyle"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "AutomationsSection"
            },
            {
              "kind": "FragmentSpread",
              "name": "ConfigurationSection"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_projectByIdOrKey"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b0772f176e59fd48837be217e75a3ed8d5f7c6116af1154314d5f43b3e4fad53",
    "metadata": {},
    "name": "LevelUpSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "de9b5f8b8496cbf13e33ddeff765615f";

export default node;
